import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-transcript"
export default class extends Controller {
  static targets = ["toggler", "panel", "mediaView"]

  connect() {
  }

  toggle() {
    document.startViewTransition(() =>
      this.mediaViewTarget.classList.toggle('transcript-expanded')
    );
  }
}